import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getColumnSortOrder } from "~/shared/ui/TableV2/lib/applyColumnSort";

/**
 * Колонки таблицы отчётов, по которым возможна сортировка.
 * Сортировка серверная: getIndicatorGroups/getIndicatorReports
 * принимают sortField/sortType.
 */
export const INDICATOR_REPORTS_SORTABLE_COLUMNS = [
  "id",
  "nameRu",
  "status",
  "createdAt",
  "updatedAt",
];

export const getIndicatorReportsColumns = (
  t: TFunction,
  options: string[],
  sortField?: string,
  sortType?: string,
): ColumnsType<any> =>
  options.map((option) => {
    const sortable = INDICATOR_REPORTS_SORTABLE_COLUMNS.includes(option);
    const sortOrder = getColumnSortOrder(option, sortField, sortType);

    return {
      title: t(`reports_list.${option}`),
      dataIndex: option,
      key: option,
      // Серверная сортировка: sorter: true только включает стрелки в шапке
      ...(sortable ? { sorter: true, sortOrder } : {}),
      render: (value: any) => <span>{value}</span>,
    };
  });
